
export default {
	name: 'boolYesNo',
	handler: {
		update: function (element, valueAccessor, allBindingsAccessor) {
			let value = valueAccessor();
			// let allBindings = allBindingsAccessor();

			let valueUnwrapped = ko.utils.unwrapObservable(value);

			if (valueUnwrapped === true || valueUnwrapped === 'true' || valueUnwrapped === 't')
			{
				$(element).text('Yes');
				// valueAccessor()(true);
			}
			else
			{
				$(element).text('No');
				// valueAccessor()(false);
			}
		}
	}
};
